import { makeStyles } from "@material-ui/core";
import React from "react";
import { Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";

const useStyle = makeStyles((theme) => ({
    crossBtn: {
        position: "absolute",
        top: "-3%",
        right: "3%",
    },
}));

const UnSavedChangesPopUp = ({
    show,
    onClose,
    message,
    handleSave,
    onCross,
    saveBtn = "Discard Changes and Leave",
    cancelBtn = "Stay on Page"
}) => {
    const classes = useStyle();

    return (
        <div>
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered
            >
                <Modal.Body className="text-center my-6">
                    {/* <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip">close to edit again</Tooltip>
                        }
                    >
                        <button
                            type="button"
                            className={`close ${classes.crossBtn}`}
                            onClick={() => onCross()}
                        >
                            <span aria-hidden="true">&times;</span>
                            <span className="sr-only">Close</span>
                        </button>
                    </OverlayTrigger> */}
                    <div className="screenAlert-icon screenAlert-warning scaleWarning">
                            <span className="screenAlert-body pulseWarningIns"></span>
                            <span className="screenAlert-dot pulseWarningIns"></span>
                        </div>
                    <h2 className="text-center text-capitalize">{message}</h2>
                    <p className="font-size-h5 mb-6">
                    You’ve made changes that haven’t been saved.
Are you sure you want to leave this page?
                    </p>
                    <Button
                        className="mr-6 px-8 text-capitalize"
                        variant="danger"
                        // onClick={() => onClose()}
                        onClick={() => onCross()}
                    >
                     {cancelBtn}
                    </Button>
                    <Button
                        className="px-8 text-capitalize"
                        variant="primary"
                        // onClick={() => {
                        //     handleSave();
                        // }}
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {saveBtn}
                    </Button>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default UnSavedChangesPopUp;
